import actionTypes from "./GRSMMAMF01ActionType";

// レスポンスState定義
const infoState = {
    isFetching: false,
    overViewData: [],
    isError: false,
    err_type: "",
    err_detail: []
};

// レスポンスState定義
const initialState = {
    isFetching: false,
    data: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 案件応募者情報
 */
const initialSelectedCaseCandidateState = {
    isFetching: false,
    overViewData: [],
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 応募者ステータス
 */
const initialSelectedCandidateState = {
    isFetching: false,
    data: {},
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * 応募者一覧データ取得
 * @param {*} state
 * @param {*} action
 */
export const getCandidateList = (state = infoState, action) => {
    switch (action.type) {
        case actionTypes.GET_CANDIDATE_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                overViewData: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_CANDIDATE_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_CANDIDATE_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: [],
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_CANDIDATE_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 応募者詳細取得
 * @param {*} state
 * @param {*} action
 */
export const getCandidateDetail = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CANDIDATE_DETAIL_REQUEST:
            return Object.assign({}, state.candidateDetail, {
                isFetching: true,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_CANDIDATE_DETAIL_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_CANDIDATE_DETAIL_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_CANDIDATE_DETAIL_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 案件応募者リストを取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getSelectedCaseCandidateList = (state = initialSelectedCaseCandidateState, action) => {
    switch (action.type) {
        case actionTypes.GET_SELECTED_CASE_CANDIDATE_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                overViewData: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_SELECTED_CASE_CANDIDATE_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: action.data.data,
                isError: action.data.isError,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_SELECTED_CASE_CANDIDATE_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: [],
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_SELECTED_CASE_CANDIDATE_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                overViewData: [],
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};

/**
 * 応募者ステータスチェックReducer
 * @param {*} state
 * @param {*} action
 */
export const checkSelectedCandidateStatus = (state = initialSelectedCandidateState, action) => {
    switch (action.type) {
        case actionTypes.CHECK_SELECTED_CANDIDATE_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.CHECK_SELECTED_CANDIDATE_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: action.data.isError,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.CHECK_SELECTED_CANDIDATE_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.CHECK_SELECTED_CANDIDATE_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
